import { ChevronLeft, ChevronRight } from 'lucide-react'
import { cn } from '../../lib/utils'
import { DropdownSelect } from './DropdownSelect'
import { PAGE_SIZE_OPTIONS } from '../../hooks/usePersistedPageSize'

interface Props {
  page: number
  totalPages: number
  total: number
  limit: number
  onPageChange: (page: number) => void
  /** When provided, renders a rows-per-page selector. */
  onPageSizeChange?: (size: number) => void
}

export function Pagination({ page, totalPages, total, limit, onPageChange, onPageSizeChange }: Props) {
  const start = (page - 1) * limit + 1
  const end = Math.min(page * limit, total)

  return (
    <div className="flex items-center justify-between px-4 py-3 border-t border-gray-200">
      <div className="flex items-center gap-3">
        <p className="text-sm text-gray-600">
          {total > 0 ? `Showing ${start}–${end} of ${total}` : 'No results'}
        </p>
        {onPageSizeChange && (
          <div className="flex items-center gap-1.5 text-sm text-gray-500">
            <span>Rows:</span>
            <div className="w-24">
              <DropdownSelect
                dropUp
                value={String(limit)}
                onChange={v => onPageSizeChange(Number(v))}
                options={PAGE_SIZE_OPTIONS.map(n => ({ value: String(n), label: String(n) }))}
              />
            </div>
          </div>
        )}
      </div>
      <div className="flex items-center gap-1">
        <button
          onClick={() => onPageChange(page - 1)}
          disabled={page <= 1}
          className={cn('btn btn-ghost btn-sm', page <= 1 && 'opacity-40')}
        >
          <ChevronLeft className="w-4 h-4" />
        </button>
        <span className="text-sm text-gray-600 px-2">
          {page} / {totalPages || 1}
        </span>
        <button
          onClick={() => onPageChange(page + 1)}
          disabled={page >= totalPages}
          className={cn('btn btn-ghost btn-sm', page >= totalPages && 'opacity-40')}
        >
          <ChevronRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  )
}
